export default function CtaBand() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-xl bg-foreground-950">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20cinematic%20dark%20newspaper%20printing%20press%20floor%20with%20warm%20amber%20spotlights%20and%20sheets%20of%20paper%20in%20motion%2C%20deep%20crimson%20and%20gold%20light%20bleed%2C%20editorial%20press%20atmosphere%2C%20moody%20documentary%20photography%2C%20high%20contrast%20film%20grain&width=1600&height=520&seq=cta-band-2026&orientation=landscape"
            alt="最新黑料本周汇总新近合集滚动更新"
            title="最新黑料 - 每周更新的黑料档案库"
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/30" />
          <div className="relative z-10 px-6 md:px-10 py-10 md:py-14 flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="flex-1">
              <p className="inline-flex items-center gap-2 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 px-3 py-1 text-[12.5px] tracking-wide">
                <i className="ri-calendar-check-line w-4 h-4 text-accent-300 flex items-center justify-center" />
                每周日 22:00 · 自动归档
              </p>
              <h2 className="mt-4 font-heading text-[26px] md:text-[34px] font-black text-background-50 leading-snug">
                把「最新黑料」存进收藏夹，
                <br className="hidden md:block" />
                下周三分钟补完一周。
              </h2>
              <p className="mt-3 text-[14px] text-background-100/80 max-w-[520px]">
                本周汇总、近期盘点与本月黑料新近合集都在这一个入口更新。翻得快不如回得勤——常回来，不脱节。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="#weekly"
                className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-[15px] font-bold text-background-50 hover:bg-primary-600 transition-colors"
              >
                <i className="ri-add-circle-line w-4 h-4 flex items-center justify-center" /> 加入本周档案
              </a>
              <a
                href="#timeline"
                className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-background-50/10 border border-background-50/25 px-6 py-3 text-[15px] font-semibold text-background-50 hover:bg-background-50/20 transition-colors"
              >
                从时间线开始补
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}